import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  RegulationFilterModel,
  FilterViewModel,
  MasterFilterModel,
} from 'src/app/core/models/regulation';
import { FormControl } from '@angular/forms';
import { PlanType } from 'src/app/core/enums/user';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { UserProfile } from 'src/app/core/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { RuleTypeName } from 'src/app/core/models/rulebook';
import { MasterHelper, Logger } from 'src/app/core/utilities';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { RegulationService } from 'src/app/core/services/regulation';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { LibraryType } from 'src/app/core/enums/regulator/regulator-status';
import { RegulationFilterViewModel } from 'src/app/core/models/regulation/regulation.model';
import { UserRegulatorFilter } from 'src/app/core/models/filter-model/user-regulator-filter';
import { CommonService } from 'src/app/core/services/common/common.service';
import { GroupingModel } from 'src/app/core/models/regulation/regulation-filter.model';
import { Store } from '@ngrx/store';
import { updateGroupBy } from 'src/app/state/grouping/grouping.actions';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { GlobalService } from 'src/app/core/services/global/global.service';
// import { time } from 'console';

@Component({
  selector: 'app-regulatory-filters',
  templateUrl: './regulatory-filters.component.html',
  styleUrls: ['./regulatory-filters.component.scss']
})
export class RegulatoryFiltersComponent implements OnInit {
  [x: string]: any;

  @Input() filterPersistenceKey = '';
  @Input() userJurisdiction: ItemIdModel[] = [];
  @Input() groupByEnabled = false;
  @Output() OnFilter = new EventEmitter<any>();
  @ViewChild('autoKeyword') autoKeyword!: MatAutocomplete;
  @ViewChild('keywordInput') keywordInput!: ElementRef<HTMLInputElement>;
  @Output() countFiltersItem = new EventEmitter();
  @Input()
  IsOpenFilter!: boolean;
  user: UserProfile;
  titles: string[] = [];
  types: string[] = [];
  topics: string[] = [];
  isLoadingFilters = false;
  descriptions: string[] = [];
  linkedRules: string[] = [];
  keyCtrl = new FormControl();
  ruleTypeNames: RuleTypeName[];
  ruleTypeNameEnum = RuleTypeName;
  masterFilters: MasterFilterModel;
  filteredKeywords: Observable<string[]>;
  regulationFilter!: RegulationFilterModel;
  groupingFilter!: GroupingModel;
  userRegulatorFilter: UserRegulatorFilter;
  userRegulatorFilterData: Array<UserRegulatorFilter>;
  savedFilterId: any;
  searchTitle: string;
  isLoader = false;
  isDeleteLoader = false;
  toastModel: ToastViewModel;
  isToastShow = false;
  urlType = '';
  regulationLibraryId = 0;
  regulationLibraryType!: LibraryType;
  keywords: string[] = [];
  searchedKeywords = [];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  isSavedSearchElementDelete: boolean = false;
  multipleIds: string[] = ["Similar Ids"];

  searchedTopics: FilterViewModel[] = [];
  searchedRegulators: FilterViewModel[] = [];
  searchedStatus: FilterViewModel[] = [];
  searchedJurisdiction: FilterViewModel[] = [];
  searchedCountries: FilterViewModel[] = [];
  searchedGeographies: FilterViewModel[] = [];
  searchRuleTopic: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchTerm: FormControl = new FormControl();
  searchRegulatorCntrl: FormControl = new FormControl();
  searchRuleTopicFormControl: FormControl = new FormControl();
  searchStatusCntrl: FormControl = new FormControl();
  searchJurisdictionCntrl: FormControl = new FormControl();
  searchCountryCntrl: FormControl = new FormControl();
  searchGeographyCntrl: FormControl = new FormControl();

  @ViewChild('statusInput')
  statusInput!: ElementRef<HTMLInputElement>;
  @ViewChild('statusAutocomplete')
  statusAutocomplete!: MatAutocomplete;

  @ViewChild('regulatorInput')
  regulatorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('regulatorAutocomplete')
  regulatorAutocomplete!: MatAutocomplete;
  @ViewChild('regulatorAutoTrigger')
  regulatorAutoTrigger!: MatAutocompleteTrigger;

  @ViewChild('jurisdictionInput')
  jurisdictionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('jurisdictionAutocomplete')
  jurisdictionAutocomplete!: MatAutocomplete;

  @ViewChild('countryInput')
  countryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('countryAutoComplete')
  countryAutoComplete!: MatAutocomplete;
  @ViewChild('countryAutoTrigger')
  countryAutoTrigger!: MatAutocompleteTrigger;

  @ViewChild('geographyInput')
  geographyInput!: ElementRef<HTMLInputElement>;
  @ViewChild('geographyAutoComplete')
  geographyAutoComplete!: MatAutocomplete;
  @ViewChild('geographyAutoTrigger')
  geographyAutoTrigger!: MatAutocompleteTrigger;

  @ViewChild('ruleTopicInput')
  ruleTopicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('ruleTopicAutocomplete')
  ruleTopicAutocomplete!: MatAutocomplete;
  @ViewChild('ruleTopicAutoTrigger')
  ruleTopicAutoTrigger!: MatAutocompleteTrigger;
  actionType: string = '';

  constructor(
    private datePipe: DatePipe,
    private regulationService: RegulationService,
    private sessionService: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    private store: Store<any>,
    private _globalService: GlobalService
  ) {
    this.user = new UserProfile();
    this.masterFilters = new MasterFilterModel();
    this.regulationFilter = new RegulationFilterModel();
    this.groupingFilter = new GroupingModel();
    this.regulationFilter.Filters = new RegulationFilterViewModel();
    this.userRegulatorFilter = new UserRegulatorFilter();
    this.userRegulatorFilterData = [];
    this.searchTitle = '';
    this.toastModel = new ToastViewModel();
    this.ruleTypeNames = [
      RuleTypeName.GDPR,
      RuleTypeName.CRR,
      RuleTypeName.APAC
    ];

    this.filteredKeywords = this.keyCtrl.valueChanges.pipe(map((key: string | null) => key ? this._filter(key) : this.keywords.slice()));
    this.savedFilterId = this.fetchFromBrowser('_sfid');
    const url = this.router.url;
    this.urlType = url ? url === '/change-viewer/open' ? 'Open'
      : url === '/change-viewer/actioned' ? 'Actioned' : url === '/change-viewer/future-updates' ? 'Future Updates' : 'Other' : 'Open';

    if (url.indexOf('/change-viewer/regulation-library') >= 0) {
      // tslint:disable-next-line:no-string-literal
      this.regulationLibraryId = Number(this.route.snapshot.params['id']);
      // tslint:disable-next-line:no-string-literal
      this.regulationLibraryType = Number(this.route.snapshot.params['type']);
    }
  }

  ngOnInit(): void {
    const persistFilter = JSON.parse(this.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    if (persistFilter) {
      this.regulationFilter = persistFilter;
      this.multipleIds=["Similar Ids:"+this.regulationFilter.SimilarIdFor]
      this.regulationFilter.GroupBy = this.regulationFilter.GroupBy || 'MappingId';
    } else {
      this.initFilters();
    }
    this.getUserProfile();
  }

  setDivision(): void {
    const persistFilter = JSON.parse(this.fetchFromBrowser(this.filterPersistenceKey) as string) as RegulationFilterModel;
    if (persistFilter) {
      this.regulationFilter.FilterType = persistFilter.FilterType;
      this.regulationFilter.divisionId = persistFilter.divisionId;
    } else {
      if (this.userJurisdiction && this.userJurisdiction.length > 0) {
        if (this.regulationFilter.divisionId === 0) {
          this.regulationFilter.divisionId = this.userJurisdiction[0].id;
        }
      } else {
        this.regulationFilter.divisionId = 0;
      }
    }
    localStorage.setItem('selectedDivision', this.regulationFilter.divisionId.toString());
  }

  async getUserProfile() {
    this.user = await this._globalService.getLoginUserData();
    if (this.user) {
      if (this.user.planType === PlanType.Suisse) {
        this.regulationFilter.MappingID = ['FC'];
      }
      this.getMasterFilters();
      this.getUserFiltersOnInit();
    }
  }

  TriggerAction(): void {
    this.setDivision();
    this.groupingFilter.GroupBy = this.regulationFilter.GroupBy
    this.regulationFilter.SortKey = 'Date';
    const filter = MasterHelper.parseRegulationFilters(this.regulationFilter);
    this.regulationFilter.UserId = this.user.userId;
    this.regulationFilter.FromDate = this.datePipe.transform(this.regulationFilter.FromDate, "yyyy-MM-dd")!;
    this.regulationFilter.ToDate = this.datePipe.transform(this.regulationFilter.ToDate, "yyyy-MM-dd")!;
    if (this.savedFilterId > 0) {
      this.userRegulatorFilter.id = this.savedFilterId;
      this.userRegulatorFilter.userId = this.user.userId;
      this.userRegulatorFilter.filterJson = JSON.stringify(filter);
      //this.addOrUpdateUserFilters(this.userRegulatorFilter, this.regulationFilter);
    }
    this.regulationFilter.regulationLibraryType = this.regulationLibraryType;
    this.regulationFilter.regulationLibraryId = this.regulationLibraryId;
    if (this.savedFilterId) {
      this.saveOnBrowser('_sfid', this.savedFilterId.toString());
    } else {
      this.saveOnBrowser('_sfid', 'NotSavedFilter');
    }
    this.userRegulatorFilter = new UserRegulatorFilter();
    this.searchTitle = '';
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(filter));
    this.OnFilter.emit({ regulationFilter: this.regulationFilter, groupingFilter: this.groupingFilter });
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }


  add(event: MatChipInputEvent): void {
    if (!this.autoKeyword.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.SearchQuery?.filter((option: string) => option.trim() == value.trim());
      if (filterResult && filterResult.length > 0) {
        event.chipInput!.clear();
        return;
      }
      if ((value || '').trim()) {
        this.regulationFilter.SearchQuery.push(value.trim());
      }
      event.chipInput!.clear();
      this.keyCtrl.setValue(null);
    }
  }

  remove(fruit: string): void {
    const index = this.regulationFilter.SearchQuery.indexOf(fruit);
    if (index >= 0) {
      this.regulationFilter.SearchQuery.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.regulationFilter.SearchQuery.push(event.option.viewValue);
    this.keywordInput.nativeElement.value = '';
    this.keyCtrl.setValue(null);
    this.keyCtrl.disable();
    this.keyCtrl.enable();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.keywords.filter(
      fruit => fruit.toLowerCase().indexOf(filterValue) === 0
    );
  }

  // title
  addTitle(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.regulationFilter.Filters.Title?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.regulationFilter.Filters.Title.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeTitle(title: string): void {
    const index = this.regulationFilter.Filters.Title.indexOf(title);

    if (index >= 0) {
      this.regulationFilter.Filters.Title.splice(index, 1);
    }
  }
  // end title
  // type
  addType(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.regulationFilter.Filters.PubType?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.regulationFilter.Filters.PubType.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeType(type: string): void {
    const index = this.regulationFilter.Filters.PubType.indexOf(type);

    if (index >= 0) {
      this.regulationFilter.Filters.PubType.splice(index, 1);
    }
  }
  // end type

  // id
  addRegulationId(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.regulationFilter.RegulationId.push(+value.trim());
    }
    event.chipInput!.clear();
  }

  removeRegulationId(type: string): void {
    const index = this.regulationFilter.RegulationId.indexOf(+type);

    if (index >= 0) {
      this.regulationFilter.RegulationId.splice(index, 1);
    }
  }
  removeAllRegulationId(): void {
    this.regulationFilter.RegulationId = [];
    this.regulationFilter.SimilarIdFor=0;
    this.regulationFilter.IsSimilarId=false;
  }
  // end id

  // topic
  addTopic(event: MatChipInputEvent): void {
    if (!this.ruleTopicAutocomplete.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.Filters.RuleTopic?.filter((option: string) => option.trim() == value.trim());
      if (filterResult && filterResult.length > 0) {
        event.chipInput!.clear();
        return;
      }
      if (!this.regulationFilter.Filters.RuleTopic) {
        this.regulationFilter.Filters.RuleTopic = [];
        this.regulationFilter.Filters.RuleTopic.push(value.trim());
      }
      if ((value || '').trim()) {
        this.regulationFilter.Filters.RuleTopic.push(value.trim());
      }
      event.chipInput!.clear();
      this.searchRuleTopicFormControl.setValue(null);
    }
    this.filterRuleTopicWithoutSelectedItem();
  }

  removeTopic(type: string): void {
    const index = this.regulationFilter.Filters.RuleTopic.indexOf(type);

    if (index >= 0) {
      this.regulationFilter.Filters.RuleTopic.splice(index, 1);
    }
    this.filterRuleTopicWithoutSelectedItem();
  }
  // end topic

  // description
  addDescription(event: MatChipInputEvent): void {
    const value = event.value;

    if ((value || '').trim()) {
      this.regulationFilter.Filters.Description.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeDescription(type: string): void {
    const index = this.regulationFilter.Filters.Description.indexOf(type);

    if (index >= 0) {
      this.regulationFilter.Filters.Description.splice(index, 1);
    }
  }
  // end description

  // linkedRules
  addLinkedRule(event: MatChipInputEvent): void {
    const value = event.value;
    let filterResult = this.regulationFilter.Filters.LinkedRules?.filter((option: string) => option.trim() == value.trim());
    if (filterResult && filterResult.length > 0) {
      event.chipInput!.clear();
      return;
    }
    if ((value || '').trim()) {
      this.regulationFilter.Filters.LinkedRules.push(value.trim());
    }
    event.chipInput!.clear();
  }

  removeLinkedRule(type: string): void {
    const index = this.regulationFilter.Filters.LinkedRules.indexOf(type);

    if (index >= 0) {
      this.regulationFilter.Filters.LinkedRules.splice(index, 1);
    }
  }

  filterRegulators(search: string): any {
    return this.filterRegulatorByCountry().length > 0 ?
      this.filterRegulatorByCountry().filter(option =>
        option.name.toLowerCase().includes(search.toLowerCase())
      ) : this.masterFilters.regulators.filter(option =>
        option.name.toLowerCase().includes(search.toLowerCase())
      );
  }

  filterCountry(search: string): any {
    return this.filterCountryByGeography().length > 0 ?
      this.filterCountryByGeography().filter(option =>
        option.name.toLowerCase().includes(search.toLowerCase())
      ) : this.masterFilters.countries.filter(option =>
        option.name.toLowerCase().includes(search.toLowerCase())
      );
  }
  filterGeography(search: string): any {
    return this.masterFilters.geographys.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }


  filterRuleTopics(search: string): any {
    // return this.searchedTopics.filter(value => value.Name.toLowerCase().indexOf(search.toLowerCase()) === 0);
    return this.masterFilters.ruleTopics.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterStatus(search: string): any {
    return this.searchedStatus.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterJurisdiction(search: string): any {
    return this.searchedJurisdiction.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  async toggleAdvanceFilters(): Promise<void> {
    this.regulationFilter.IsAdvance = !this.regulationFilter.IsAdvance;
    this.regulationFilter.Filters = new RegulationFilterViewModel();
    this.saveOnBrowser(
      this.filterPersistenceKey,
      JSON.stringify(this.regulationFilter)
    );
  }

  addStatus(event: MatChipInputEvent): void {
    if (!this.statusAutocomplete.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.Status?.filter((option: string) => option.trim() == value.trim());
      if (filterResult && filterResult.length > 0) {
        event.chipInput!.clear();
        return;
      }
      if ((value || '').trim()) {
        (this.regulationFilter.Status as string[]).push(value);
      }

      // Reset the input value
      event.chipInput!.clear();
      this.searchStatusCntrl.setValue(null);
    }
  }

  removeStatus(status: string): void {
    const index = (this.regulationFilter.Status as string[]).indexOf(status);

    if (index >= 0) {
      (this.regulationFilter.Status as string[]).splice(index, 1);
    }
  }

  selectedStatusEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.regulationFilter.Status) {
      this.regulationFilter.Status.push(event.option.viewValue);
    } else {
      this.regulationFilter.Status = [];
      this.regulationFilter.Status.push(event.option.viewValue);
    }
    this.statusInput.nativeElement.value = '';
    this.searchStatusCntrl.setValue(null);
    this.searchStatusCntrl.disable();
    this.searchStatusCntrl.enable();
  }

  addRegulator(event: MatChipInputEvent): void {
    if (!this.regulatorAutocomplete.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.MappingID?.filter((option: string) => option == value);
      if (filterResult && filterResult.length > 0) {
        event.chipInput!.clear();
        return;
      }
      if (value) {
        if (!this.regulationFilter.MappingID) {
          this.regulationFilter.MappingID = [];
          this.regulationFilter.MappingID.push(value);
        }
        if ((value || '').trim()) {
          (this.regulationFilter.MappingID as string[]).push(value);
        }
        event.chipInput!.clear();
        this.filterRegulatorWithoutSelectedItem();
      }
    }

  }

  removeRegulator(regulator: string): void {
    if (!this.regulationFilter.MappingID) {
      this.regulationFilter.MappingID = [];
    }
    const index = (this.regulationFilter.MappingID as string[]).indexOf(
      regulator
    );

    if (index >= 0) {
      (this.regulationFilter.MappingID as string[]).splice(index, 1);
    }
    this.filterRegulatorWithoutSelectedItem();
  }

  selectedRegulatorEvent(event: MatAutocompleteSelectedEvent): void {
    let filterResult = this.regulationFilter.MappingID?.filter((option: string) => option == event.option.viewValue);
    if (filterResult && filterResult.length > 0) {
      this.regulatorInput.nativeElement.value = '';
      this.searchRegulatorCntrl.setValue(null);
      this.searchRegulatorCntrl.disable();
      this.searchRegulatorCntrl.enable();
      return;
    }
    if (this.regulationFilter.MappingID) {
      this.regulationFilter.MappingID.push(event.option.viewValue);
    } else {
      this.regulationFilter.MappingID = [];
      this.regulationFilter.MappingID.push(event.option.viewValue);
    }

    this.regulatorInput.nativeElement.value = '';
    this.searchRegulatorCntrl.setValue(null);
    this.searchRegulatorCntrl.disable();
    this.searchRegulatorCntrl.enable();
    this.filterRegulatorWithoutSelectedItem();
  }
  // function to filter regulator without selected item
  filterRegulatorWithoutSelectedItem() {
    const filteredArray = this.masterFilters.regulators.filter(item => !this.regulationFilter.MappingID?.includes(item.name));
    this.searchedRegulators = filteredArray;
  }

  addJurisdiction(event: MatChipInputEvent): void {
    if (!this.jurisdictionAutocomplete.isOpen) {
      const value = event.value;
      if (!this.regulationFilter.Jurisdictions) {
        this.regulationFilter.Jurisdictions = [];
        this.regulationFilter.Jurisdictions.push(value);
      }

      if ((value || '').trim()) {
        (this.regulationFilter.Jurisdictions as string[]).push(value);
      }
      // Reset the input value
      event.chipInput!.clear();
      this.searchJurisdictionCntrl.setValue(null);
    }
  }

  removeJurisdiction(jurisdiction: string): void {
    if (!this.regulationFilter.Jurisdictions) {
      this.regulationFilter.Jurisdictions = [];
    }
    const index = (this.regulationFilter.Jurisdictions as string[]).indexOf(
      jurisdiction
    );

    if (index >= 0) {
      (this.regulationFilter.Jurisdictions as string[]).splice(index, 1);
    }
  }

  selectedJurisdictionEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.regulationFilter.Jurisdictions) {
      this.regulationFilter.Jurisdictions.push(event.option.viewValue);
    } else {
      this.regulationFilter.Jurisdictions = [];
      this.regulationFilter.Jurisdictions.push(event.option.viewValue);
    }
    this.jurisdictionInput.nativeElement.value = '';
    this.searchJurisdictionCntrl.setValue(null);
    this.searchJurisdictionCntrl.disable();
    this.searchJurisdictionCntrl.enable();
  }

  addCountry(event: MatChipInputEvent): void {
    if (!this.countryAutoComplete.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.Country.filter((option: string) => option == value);
      if (filterResult.length > 0) {
        event.chipInput!.clear();
        this.searchCountryCntrl.setValue(null);
        return;
      }
      if (value) {
        if (!this.regulationFilter.Country) {
          this.regulationFilter.Country = [];
          this.regulationFilter.Country.push(value);
        }
        if ((value || '').trim()) {
          (this.regulationFilter.Country as string[]).push(value);
        }
        event.chipInput!.clear();
        this.searchCountryCntrl.setValue(null);

        this.searchedRegulators = this.filterRegulatorByCountry();
        this.regulationFilter.MappingID = [];
      }
      this.filterCountryWithoutSelectedItem();
    }
  }

  removeCountry(country: string): void {
    if (!this.regulationFilter.Country) {
      this.regulationFilter.Country = [];
    }
    const index = (this.regulationFilter.Country as string[]).indexOf(country);
    if (index >= 0) {
      (this.regulationFilter.Country as string[]).splice(index, 1);
      if (this.regulationFilter.Country.length > 0) {
        this.searchedRegulators = this.filterRegulatorByCountry();
      } else {
        this.searchedRegulators = this.masterFilters.regulators;
      }
      this.regulationFilter.MappingID = [];
    }
    this.filterCountryWithoutSelectedItem();
  }

  selectedCountryEvent(event: MatAutocompleteSelectedEvent): void {
    let filterResult = this.regulationFilter.Country.filter((option: string) => option == event.option.viewValue);
    if (filterResult.length > 0) {
      this.countryInput.nativeElement.value = '';
      this.searchCountryCntrl.setValue(null);
      this.searchCountryCntrl.disable();
      this.searchCountryCntrl.enable();
      return;
    }
    if (this.regulationFilter.Country) {
      this.regulationFilter.Country.push(event.option.viewValue);
    } else {
      this.regulationFilter.Country = [];
      this.regulationFilter.Country.push(event.option.viewValue);
    }
    this.searchedRegulators = this.filterRegulatorByCountry();

    this.countryInput.nativeElement.value = '';
    this.searchCountryCntrl.setValue(null);
    this.searchCountryCntrl.disable();
    this.searchCountryCntrl.enable();

    this.regulationFilter.MappingID = [];
    this.filterCountryWithoutSelectedItem();
  }
  // function to filter geography without selected item
  filterCountryWithoutSelectedItem() {
    const filteredArray = this.masterFilters.countries.filter(item => !this.regulationFilter.Country.includes(item.name));
    this.searchedCountries = filteredArray;
  }
  filterRegulatorByCountry(): FilterViewModel[] {
    const regArray: any[] = [];
    this.regulationFilter.Country.forEach(element => {
      const resultArr = this.masterFilters.regulators.filter(option =>
        option.name.toLowerCase().includes(element.toLowerCase()));
      resultArr.forEach(element2 => {
        regArray.push(element2);
      });
    });
    return regArray;
  }

  addGeography(event: MatChipInputEvent): void {
    if (!this.geographyAutoComplete.isOpen) {
      const value = event.value;
      let filterResult = this.regulationFilter.Geography.filter((option: string) => option == value);
      if (filterResult.length > 0) {
        event.chipInput!.clear();
        this.searchGeographyCntrl.setValue(null);
        return;
      }
      if (value) {
        if (!this.regulationFilter.Geography) {
          this.regulationFilter.Geography = [];
          this.regulationFilter.Geography.push(value);
        }
        if ((value || '').trim()) {
          (this.regulationFilter.Geography as string[]).push(value);
        }
        event.chipInput!.clear();
        this.searchGeographyCntrl.setValue(null);
        this.searchedCountries = this.filterCountryByGeography();
        this.searchedRegulators = this.filterRegulatorByGeography();
        this.regulationFilter.MappingID = [];
        this.regulationFilter.Country = [];
        this.filterGeographyWithoutSelectedItem();
      }
    }
  }

  removeGeography(Geography: string): void {
    if (!this.regulationFilter.Geography) {
      this.regulationFilter.Geography = [];
    }
    const index = (this.regulationFilter.Geography as string[]).indexOf(Geography);
    if (index >= 0) {
      (this.regulationFilter.Geography as string[]).splice(index, 1);

      if (this.regulationFilter.Geography.length > 0) {
        this.searchedCountries = this.filterCountryByGeography();
        this.searchedRegulators = this.filterRegulatorByGeography();
      } else {
        this.searchedCountries = this.masterFilters.countries;
        this.searchedRegulators = this.masterFilters.regulators;
      }
      this.regulationFilter.MappingID = [];
      this.regulationFilter.Country = [];
    }
    this.filterGeographyWithoutSelectedItem();
  }

  selectedGeographyEvent(event: MatAutocompleteSelectedEvent): void {
    //filter geography array
    let filterResult = this.regulationFilter.Geography.filter((option: string) => option == event.option.viewValue);
    if (filterResult.length > 0) {
      this.geographyInput.nativeElement.value = '';
      this.searchGeographyCntrl.setValue(null);
      this.searchGeographyCntrl.disable();
      this.searchGeographyCntrl.enable();
      return;
    }
    if (this.regulationFilter.Geography) {
      this.regulationFilter.Geography.push(event.option.viewValue);
    } else {
      this.regulationFilter.Geography = [];
      this.regulationFilter.Geography.push(event.option.viewValue);
    }
    this.searchedCountries = this.filterCountryByGeography();
    this.searchedRegulators = this.filterRegulatorByGeography();
    this.geographyInput.nativeElement.value = '';
    this.searchGeographyCntrl.setValue(null);
    this.searchGeographyCntrl.disable();
    this.searchGeographyCntrl.enable();

    this.regulationFilter.MappingID = [];
    this.regulationFilter.Country = [];
    this.filterGeographyWithoutSelectedItem();
  }
  // function to filter geography without selected item
  filterGeographyWithoutSelectedItem() {
    const filteredArray = this.masterFilters.geographys.filter(item => !this.regulationFilter.Geography.includes(item.name));
    this.searchedGeographies = filteredArray;
  }
  filterRegulatorByGeography(): FilterViewModel[] {
    const regArray: any = [];
    this.regulationFilter.Geography.forEach(element => {
      const resultArr = this.masterFilters.regulators.filter(option =>
        option.geography.toLowerCase().includes(element.toLowerCase()));
      resultArr.forEach(element2 => {
        regArray.push(element2);
      });
    });
    return regArray;
  }
  filterCountryByGeography(): FilterViewModel[] {
    const conArray: any = [];
    this.regulationFilter.Geography.forEach(element => {
      const resultArr = this.masterFilters.countries.filter(option =>
        option.geography.toLowerCase().includes(element.toLowerCase()));
      resultArr.forEach(element2 => {
        conArray.push(element2);
      });
    });
    return conArray;
  }


  toggleClass(event: any, itemClass: string): void {
    if (event) {
      const hasClass = event.target.classList.contains(itemClass);
      if (hasClass) {
        event.target.classList = '';
      } else {
        event.target.classList = itemClass;
      }
    }
  }

  resetFilters() {
    this.initFilters();
    this.OnFilter.emit({ regulationFilter: this.regulationFilter, groupingFilter: this.groupingFilter });
  }
  initFilters(): void {
    const isAdvance = this.regulationFilter && this.regulationFilter.IsAdvance ? this.regulationFilter.IsAdvance : false;
    this.savedFilterId = '';
    this.searchTitle = '';
    this.regulationFilter = new RegulationFilterModel();
    // this.regulationFilter.FromDate = MasterHelper.getDateStr(7); // Timezone Bug 442
    // this.regulationFilter.ToDate = MasterHelper.getDateStr(0); // Timezone Bug 442
    this.regulationFilter.SortKey = 'Date';
    this.regulationFilter.IsDesc = true;
    this.regulationFilter.Page = 1;
    this.regulationFilter.PageSize = 50;
    this.regulationFilter.SkipCount = 0;
    this.regulationFilter.Regulator = [];
    this.regulationFilter.MappingID = [];
    this.regulationFilter.Status = [];
    this.regulationFilter.Jurisdictions = [];
    this.regulationFilter.IsAdvance = isAdvance;
    this.regulationFilter.Filters = new RegulationFilterViewModel();
    this.regulationFilter.GroupBy = this.regulationFilter.GroupBy || 'MappingId';
    this.regulationFilter = MasterHelper.parseRegulationFilters(
      this.regulationFilter
    ) as RegulationFilterModel;
    this.searchedStatus = this.masterFilters.status;
    this.setDivision();
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter)
    );
    this.saveOnBrowser('_sfid', 'NotSavedFilter');
    this.countFiltersItem.next();
  }


  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.regulationService.getMasterFilters().subscribe((data: MasterFilterModel) => {
      this.masterFilters = data;
      this.searchedRegulators = this.masterFilters.regulators;
      this.searchedStatus = this.masterFilters.status;
      this.searchedJurisdiction = this.masterFilters.jurisdictions;
      this.searchedCountries = this.masterFilters.countries;
      this.searchedGeographies = this.masterFilters.geographys;
      this.searchedTopics = this.masterFilters.ruleTopics;
      this.isLoadingFilters = false;

      this.searchRegulatorCntrl.valueChanges.subscribe((term: any) => {
        this.searchedRegulators = term ? this.filterRegulators(term) :
          this.filterRegulatorByCountry().length > 0 ? this.filterRegulatorByCountry() :
            this.filterRegulatorByGeography().length > 0 ? this.filterRegulatorByGeography() : this.masterFilters.regulators;

      });

      this.searchRuleTopicFormControl.valueChanges.subscribe((term: any) => {
        this.searchedTopics = term ? this.filterRuleTopics(term) : this.masterFilters.ruleTopics;
      });

      this.searchStatusCntrl.valueChanges.subscribe((result: any) => {
        this.searchedStatus = result ? this.filterStatus(result) : this.masterFilters.status;
      });

      this.searchJurisdictionCntrl.valueChanges.subscribe((result: any) => {
        this.searchedJurisdiction = result ? this.filterJurisdiction(result) : this.masterFilters.jurisdictions;
      });

      this.searchCountryCntrl.valueChanges.subscribe((term: any) => {
        this.searchedCountries = term ? this.filterCountry(term) : this.filterCountryByGeography().length > 0 ? this.filterCountryByGeography() : this.masterFilters.countries;
      });
      this.searchGeographyCntrl.valueChanges.subscribe((term: any) => {
        this.searchedGeographies = term ? this.filterGeography(term) : this.masterFilters.geographys;
      });

    },
      (error: HttpErrorResponse) => {
        this.isLoadingFilters = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  getUserFilters(): void {
    this.regulationService.getUserFilters().subscribe((data: any) => {
      if (data && data.length > 0) {
        this.userRegulatorFilterData = data;
        if (!this.savedFilterId && this.userRegulatorFilterData.length > 0) {
          let FilterRow = this.userRegulatorFilterData.find(a => a.title == this.searchTitle);
          if (FilterRow) {
            this.savedFilterId = FilterRow.id;
          }
          else {
            this.savedFilterId = this.userRegulatorFilterData[0].id;
          }
          //this.savedFilterId = this.userRegulatorFilterData[0].id;
          //this.savedFilterId = 0;
          // this.saveOnBrowser('_sfid', this.savedFilterId.toString());
        }
        this.applyFilters(this.savedFilterId);
      }
      else {
        if (this.isSavedSearchElementDelete) {
          this.isSavedSearchElementDelete = false;
          this.userRegulatorFilterData = [];
          this.savedFilterId = '';
        }
      }
      this.searchTitle = '';
    });
  }
  getUserFiltersOnInit(): void {
    this.regulationService.getUserFilters().subscribe((data: any) => {
      if (data && data.length > 0) {
        this.userRegulatorFilterData = data;
        let filteredRow = this.userRegulatorFilterData.find(a => a.id == this.savedFilterId);
        if (filteredRow) {
          this.savedFilterId = this.fetchFromBrowser('_sfid');
        }
        else {
          this.savedFilterId = 0;
        }

      }
    });
  }

  SaveFilters(): void {
    this.userRegulatorFilter.title = this.searchTitle;
    this.userRegulatorFilter.userId = this.user.userId;
    this.userRegulatorFilter.filterJson = JSON.stringify(this.regulationFilter).toString();
    if (!this.userRegulatorFilter.title) {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = 'Please enter search title';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 3500);
    } else {
      let filterRow = this.userRegulatorFilterData.find(a => a.title.trim() == this.userRegulatorFilter.title.trim());
      if (filterRow) {
        this.toastModel.Title = 'Warning';
        this.toastModel.Type = 'warning';
        this.toastModel.Message = 'Search title already exists';
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
        }, 3500);
      }
      else {
        this.actionType = actionType.SaveSearch;
        this.addOrUpdateUserFilters(this.userRegulatorFilter, this.regulationFilter);
      }
      //this.savedFilterId = '';

    }
  }

  addOrUpdateUserFilters(userRegulatorFilter: UserRegulatorFilter, filter: RegulationFilterModel): void {
    this.isLoader = true;
    this.regulationService.saveFilters(userRegulatorFilter).subscribe((data: any) => {
      this.isLoader = false;
      //this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(filter));
      this.userRegulatorFilter = new UserRegulatorFilter();
      //this.searchTitle = '';
      this.getUserFilters();
    });
  }

  applyFilters(filterId: any): void {
    if (filterId > 0) {
      const userFilter = this.userRegulatorFilterData.find(a => +a.id === +filterId);
      if (userFilter) {
        this.regulationFilter = JSON.parse(userFilter.filterJson) as RegulationFilterModel;
      }
    } else if (filterId === 'Today') {
      const filter = new RegulationFilterModel();
      filter.FromDate = MasterHelper.getDateStr(0);
      filter.ToDate = MasterHelper.getDateStr(0);
      this.regulationFilter = filter;
      this.updateFilters();
    } else if (filterId === 'Yesterday') {
      const filter = new RegulationFilterModel();
      filter.FromDate = MasterHelper.getDateStr(1);
      filter.ToDate = MasterHelper.getDateStr(1);
      this.regulationFilter = filter;
      this.updateFilters();
    } else if (filterId === 'OneWeek') {
      const filter = new RegulationFilterModel();
      filter.FromDate = MasterHelper.getDateStr(7);
      filter.ToDate = MasterHelper.getDateStr(0);
      this.regulationFilter = filter;
      this.updateFilters();
    } else if (filterId === 'TwoWeek') {
      const filter = new RegulationFilterModel();
      filter.FromDate = MasterHelper.getDateStr(14);
      filter.ToDate = MasterHelper.getDateStr(0);
      this.regulationFilter = filter;
      this.updateFilters();
    } else if (filterId === 'OneMonth') {
      const filter = new RegulationFilterModel();
      filter.FromDate = MasterHelper.getDateStr(30);
      filter.ToDate = MasterHelper.getDateStr(0);
      this.regulationFilter = filter;
      this.updateFilters();
    }
    // this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
    // this.saveOnBrowser('_sfid', this.savedFilterId.toString());
  }

  updateFilters(): void {
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
  }

  deleteUserFilter(): void {
    this.isDeleteLoader = true;
    this.regulationService.removeUserFilters(this.savedFilterId).subscribe((data: any) => {
      this.isDeleteLoader = false;
      this.savedFilterId = 0;
      this.isSavedSearchElementDelete = true;
      this.getUserFilters();
      //this.applyFilters(this.savedFilterId);
    });
  }

  changeDivision(): void {
    this.regulationFilter.divisionId = +this.regulationFilter.divisionId;
    localStorage.setItem('selectedDivision', this.regulationFilter.divisionId.toString());
    this.saveOnBrowser(this.filterPersistenceKey, JSON.stringify(this.regulationFilter));
    this.TriggerAction();
  }

  getColumnSize(): string {
    if (!this.groupByEnabled) {
      if (this.urlType === 'Future Updates') {
        return 'col-lg-12';
      }
    }

    // if (this.userJurisdiction && this.userJurisdiction.length > 1) {
    //   if (this.regulationLibraryId > 0) {
    //     return this.regulationLibraryType === LibraryType.Static ? 'col-lg-10' : 'col-lg-12';
    //   } else {
    //     return 'col-lg-4';
    //   }
    // } else {
    //   if (this.regulationLibraryId > 0) {
    //     return this.regulationLibraryType === LibraryType.Static ? 'col-lg-10' : 'col-lg-4';
    //   } else {
    //     return 'col-lg-6';
    //   }
    // }
    if (this.groupByEnabled) {
      if (this.urlType === 'Future Updates') {
        return 'col-lg-10';
      }
      if (this.regulationLibraryId > 0) {
        return this.regulationLibraryType === LibraryType.Static ? 'col-lg-8' : 'col-lg-2';
      } else {
        return 'col-lg-4';
      }
    }

    if (this.regulationLibraryId > 0) {
      return this.regulationLibraryType === LibraryType.Static ? 'col-lg-10' : 'col-lg-4';
    } else {
      return 'col-lg-6';
    }
  }
  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    let filterResult = this.regulationFilter.Filters.RuleTopic?.filter((option: string) => option.trim() == event.option.viewValue.trim());
    if (filterResult && filterResult.length > 0) {
      this.ruleTopicInput.nativeElement.value = '';
      this.searchRuleTopicFormControl.setValue(null);
      this.searchRuleTopicFormControl.disable();
      this.searchRuleTopicFormControl.enable();
      return;
    }
    if (this.regulationFilter.Filters.RuleTopic) {
      this.regulationFilter.Filters.RuleTopic.push(event.option.viewValue);
    } else {
      this.regulationFilter.Filters.RuleTopic = [];
      this.regulationFilter.Filters.RuleTopic.push(event.option.viewValue);
    }
    this.ruleTopicInput.nativeElement.value = '';
    this.searchRuleTopicFormControl.setValue(null);
    this.searchRuleTopicFormControl.disable();
    this.searchRuleTopicFormControl.enable();
    this.filterRuleTopicWithoutSelectedItem();
  }
  // function to filter RuleTopic without selected item
  filterRuleTopicWithoutSelectedItem() {
    const filteredArray = this.masterFilters.ruleTopics.filter(item => !this.regulationFilter.Filters.RuleTopic?.includes(item.name));
    this.searchedTopics = filteredArray;
  }

  openCountryAutoComplete() {
    if (!this.countryAutoComplete.isOpen) {
      this.countryAutoTrigger.openPanel();
    }
  }
  openGeographyAutoComplete() {
    if (!this.geographyAutoComplete.isOpen) {
      this.geographyAutoTrigger.openPanel();
    }
  }
  openRegulatorAutoComplete() {
    if (!this.regulatorAutocomplete.isOpen) {
      this.regulatorAutoTrigger.openPanel();
    }
  }
  openRuleTopicAutoComplete() {
    if (!this.ruleTopicAutocomplete.isOpen) {
      this.ruleTopicAutoTrigger.openPanel();
    }
  }
  // DateTZChange(){
  //   let output = MasterHelper.dateCorrectionTZ(new Date(this.regulationFilter.ToDate));
  //   this.regulationFilter.ToDate = output;
  // }
}
export enum actionType {
  SaveSearch = 'SaveSearch',
  DeleteSearch = 'DeleteSearch'
}

